import { createApi } from "@reduxjs/toolkit/query/react";
import api from "@/api/api";

const axiosBaseQuery =
  () =>
  async ({ url, method, data, params }) => {
    try {
      const result = await api.request({ url, method, data, params });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status ?? -1,
          data: err.response?.data ?? err.message,
        },
      };
    }
  };

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Employee', 'Delegation', 'Request', 'Lookup', 'Policy', 'Schedule', 'Report', 'Company',
    // Metadata tags for language-sensitive cache invalidation
    'EmployeeDelegationMeta', 'EmployeeExceptionMeta', 'TimePeriod', '$RecalculateAttendance',
    'SettingsMeta', 'CompanyMeta'
  ],
  keepUnusedDataFor: 60, // seconds
  refetchOnMountOrArgChange: 30, // seconds
  refetchOnFocus: false,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});